import DetailArrArea from "./detail_arr";
function StudyDetailArea(props: any) {
  let myProps = {
    Style: {},
    select_study_use: null,
    set_page_sort: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let select_study_use = myProps.select_study_use;
  
  let section_arr: any = [];
  if (select_study_use && select_study_use.section_arr) {
    section_arr = select_study_use.section_arr;
  }
  let study_list_arr: any = [];
  if (select_study_use && select_study_use.study_arr) {
    study_list_arr = select_study_use.study_arr;
  }
  let use_det_arr: any = [];
  if (select_study_use && select_study_use.use_det_arr) {
    use_det_arr = select_study_use.use_det_arr;
  }
  
  const get_section_tags = () => {
    if (section_arr.length == 0) {
      return <div>섹션이 없습니다.</div>;
    }
    let section_tags = section_arr.map((item: any, idx: number) => {
      return (
        <div key={idx} className={Style.study_section_wrap}>
          <div className={Style.study_section_title}>
            {item.a_title}
          </div>
          <DetailArrArea
            Style={Style}
            select_study_use={select_study_use}
            section_info={item}
            study_list_arr={study_list_arr}
            use_det_arr={use_det_arr}
          ></DetailArrArea>
        </div>
      );
    });
    return section_tags;
  };

  return (
    <div>
      <div className={Style.study_title_wrap}>
        <button className="btn-l btn-dark"
          style={{ fontSize: "24px" }}
          onClick={() => { myProps.set_page_sort("list"); }}>뒤로</button>
      </div>
      <div>
        {get_section_tags()}
      </div>
    </div>
  );
};
export default StudyDetailArea;